import PropTypes from "prop-types"
import React, { useEffect, useState, useRef } from "react"
import { useDispatch } from "react-redux"
import { Modal, ModalBody } from "reactstrap"
import moment from "moment"

import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import classnames from "classnames"
import {
  Button,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  InputGroup,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"

import { useFormik } from "formik"
import * as Yup from "yup"

import CargosListado from "./CargosListado"
import { useCajaoUltimoCargo } from "store/selectors"
import { getCajaUltimoCargo as onGetCajaUltimoCargo } from "store/actions"

const CargosInsertReinscripcion = ({
  idAlumno,
  dataServicios,
  tab,
  customActiveTab,
}) => {
  //
  Date.prototype.addDays = function (days) {
    var date = new Date(this.valueOf())
    date.setDate(date.getDate() + days)
    return date
  }
  //

  const flatpickrRef = useRef(null)
  const optionsFlatpickr = {
    locale: Spanish,
    altInput: true,
    dateFormat: "d-m-y",
  }
  //
  //
  const dispatch = useDispatch()
  const ocargo = useCajaoUltimoCargo()

  const [pick_date, setPickDate] = useState(new Date().addDays(9))
  const [oUltimoCargo, setoUltimoCargo] = useState()
  const [sFechaExpiracion, setsFechaExpiracion] = useState("2000-10-01")
  const [sCantidadaCargar, setCantidadaCargar] = useState("0")

  //
  //Horizontal form
  const horizontalformik = useFormik({
    initialValues: {
      firstname: "",
      email: "",
      password: "",
      check: "",
    },
    validationSchema: Yup.object({
      firstname: Yup.string().required("This field is required"),
      email: Yup.string()
        .email()
        .matches(/^(?!.*@[^,]*,)/)
        .required("Please Enter Your Email"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .matches(RegExp("(.*[a-z].*)"), "At least lowercase letter")
        .matches(RegExp("(.*[A-Z].*)"), "At least uppercase letter")
        .matches(RegExp("(.*[0-9].*)"), "At least one number")
        .required("This field is required"),
      check: Yup.string().required("This field is required"),
    }),

    onSubmit: values => {
      // console.log("value", values.password);
    },
  })

  useEffect(() => {
    setPickDate(new Date().addDays(9))
  }, [])

  useEffect(() => {
    console.log("Rein: ", tab, "::", customActiveTab)
    if (idAlumno > 0 && tab == customActiveTab) {
      console.log("Rein: Entró")
      dispatch(
        onGetCajaUltimoCargo({
          nombreSolicitud: "getultimocargoxidgruposervicios",
          idAlumno: idAlumno,
          idGrupoServicios: 4,
        })
      )
    }
  }, [useDispatch, idAlumno, customActiveTab])

  useEffect(() => {
    if (ocargo !== undefined && tab == customActiveTab) {
      console.log("ocargo:", ocargo)
      setoUltimoCargo(ocargo)
      const item = dataServicios.find(oservicio => {
        return oservicio.id_Servicio === ocargo.id_Servicio
      })
      console.log("item: ", item)
      setCantidadaCargar(item?.Cantidad ? item.Cantidad : 9)
      if (ocargo.Fecha_Cargo) {
        const cadena =
          moment(ocargo.Fecha_Cargo).format("DD MMM, YYYY") +
          " - $" +
          ocargo.Cantidad
        console.log("cadena:", cadena)
        setsFechaExpiracion(cadena)
      }
    }
  }, [useDispatch, ocargo, customActiveTab])

  // useEffect(() => {
  //   setPickDate(new Date().addDays(9))
  // }, [])

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <Form onSubmit={horizontalformik.handleSubmit}>
            <Row className="mb-4">
              <Label
                htmlFor="Fecha_Expiracion_"
                className="col-sm-3 col-form-label"
              >
                Expira
              </Label>
              <Col sm={9}>
                <InputGroup>
                  <Flatpickr
                    ref={flatpickrRef}
                    id="Fecha_Expiracion_"
                    value={Date.parse(pick_date)}
                    className="form-control d-block"
                    placeholder="Fecha Expiracion"
                    options={optionsFlatpickr}
                  />
                </InputGroup>
                {horizontalformik.errors.firstname &&
                horizontalformik.touched.firstname ? (
                  <FormFeedback type="invalid">
                    {horizontalformik.errors.firstname}
                  </FormFeedback>
                ) : null}
              </Col>
            </Row>
            <Row className="mb-4">
              <Label
                htmlFor="horizontal-cantidad-Input_"
                className="col-sm-3 col-form-label"
              >
                Cantidad
              </Label>
              <Col sm={9}>
                <Input
                  type="number"
                  name="cantidad"
                  className="form-control"
                  id="horizontal-cantidad-Input_"
                  placeholder={sCantidadaCargar}
                  //value={oUltimoCargo?.Cantidad ? oUltimoCargo.Cantidad : 0}
                  value={horizontalformik.values.cantidad}
                  onChange={horizontalformik.handleChange}
                  onBlur={horizontalformik.handleBlur}
                  autocomplete="new-password"
                  data-1p-ignore
                  data-bwignore
                  data-lpignore="true"
                  invalid={
                    horizontalformik.touched.cantidad &&
                    horizontalformik.errors.cantidad
                      ? true
                      : false
                  }
                />
                {horizontalformik.errors.email &&
                horizontalformik.touched.email ? (
                  <FormFeedback type="invalid">
                    {horizontalformik.errors.email}
                  </FormFeedback>
                ) : null}
              </Col>
            </Row>
            <Row className="mb-4">
              <Label
                htmlFor="horizontal-lasttcharge-Input_"
                className="col-sm-3 col-form-label"
              >
                Ultima Reinscripción
              </Label>
              <Col sm={9}>
                <Input
                  type="lasttcharge"
                  name="lasttcharge"
                  className="form-control"
                  id="horizontal-lasttcharge-Input_"
                  autoComplete="off"
                  placeholder={sFechaExpiracion}
                  value={horizontalformik.values.lasttcharge}
                  onChange={horizontalformik.handleChange}
                  onBlur={horizontalformik.handleBlur}
                  invalid={
                    horizontalformik.touched.lasttcharge &&
                    horizontalformik.errors.lasttcharge
                      ? true
                      : false
                  }
                />
                {horizontalformik.errors.lasttcharge &&
                horizontalformik.touched.lasttcharge ? (
                  <FormFeedback type="invalid">
                    {horizontalformik.errors.lasttcharge}
                  </FormFeedback>
                ) : null}
              </Col>
            </Row>

            <Row className="justify-content-end">
              <Col sm={9}>
                <div className="form-check mb-4">
                  <div>
                    {horizontalformik.errors.check &&
                    horizontalformik.touched.check ? (
                      <FormFeedback type="invalid">
                        {horizontalformik.errors.check}
                      </FormFeedback>
                    ) : null}
                  </div>
                </div>

                <div>
                  <Button type="submit" color="primary" className="w-md">
                    Cargar Reinscripción
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default CargosInsertReinscripcion
